<template>
  <div class="intro">
    <div class="intro__left">
      <div class="slider__content" v-if="!isAuthMobileForm">
        <p class="heading-primary-main slider__content__main">
          FCB Visual Analytics
        </p>
        <p class="heading-primary-sub slider__content__sub">
          {{ sliders[currentSlider - 1].title }}
        </p>
      </div>
      <LoginForm></LoginForm>
    </div>
    <div class="intro__right">
      <div class="slider__item">
        <img
          :src="require(`@/assets/illustrations/slider-${currentSlider}.svg`)"
          alt=""
          class="slider__illust"
        />
      </div>
      <div class="slider__control">
        <div class="slider__indicator">
          <div class="slider__pagination">
            <span class="slider__pagination--current">0{{ currentSlider }}</span
            >/03
          </div>
          <div class="slider__progressbar">
            <div
              class="slider__progressbar--inner"
              :style="progressBarWidth"
            ></div>
          </div>
        </div>
        <button
          class="slider__button slider__button--left"
          ref="prev"
          @click="sliderPrev"
          :disabled="currentSlider === 1"
        >
          <img src="../../../assets/icons/triangle.svg" alt="" />
        </button>
        <button
          class="slider__button slider__button--right"
          @click="sliderNext"
          :disabled="currentSlider === 3"
        >
          <img src="../../../assets/icons/right.svg" alt="" />
          <span class="slider__button--seperator"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LoginForm from "@/views/auth/components/LoginForm.vue";

export default {
  components: {
    LoginForm,
  },
  data() {
    return {
      currentSlider: 1,
      sliders: [
        {
          title: "Обзоры, отчетность и аналитика Первого кредитного бюро",
        },
        {
          title: "Бизнес-кредитование",
        },
        {
          title: "Розничное кредитование",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      isAuthMobileForm: (state) => state.auth.isAuthMobileForm,
    }),
    progressBarWidth() {
      return { width: Math.ceil(33.3 * this.currentSlider) + "%" };
    },
  },
  methods: {
    sliderPrev() {
      if (this.currentSlider === 1) {
        return;
      }
      this.currentSlider--;
    },
    sliderNext() {
      if (this.currentSlider === 3) {
        return;
      }
      this.currentSlider++;
    },
  },
};
</script>

<style lang="scss" scoped>
.intro {
  background-color: #fff;
  width: 100%;
  max-width: 1110px;
  margin: auto;
  padding: 0 45px;
  display: flex;
  justify-content: space-between;
  &__right {
    max-width: 600px;
    flex-grow: 1;
  }
  @media (max-width: 650px) {
    flex-direction: column;
    padding: 0 15px;
  }
}
// @media only all and (max-width: 900px) {
//   .intro {
//     display: block;
//   }
// }
.slider {
  &__indicator {
    display: flex;
    align-items: center;
    width: 100%;
  }
  &__item {
    display: flex;
    align-items: flex-start;
    &:not(:first-child) {
      display: none;
    }
  }
  &__content {
    text-align: left;
    &__main {
      text-align: left;
    }
    &__sub {
      text-align: left;
    }
  }
  &__illust {
    width: 50vw;
    height: 43rem;
    margin-top: -4rem;
  }
  &__control {
    display: flex;
    align-items: baseline;
    margin-top: 56px;
    margin-bottom: 56px;
    justify-content: flex-end;
  }
  &__pagination {
    font-weight: 400;
    font-size: 2.4rem;
    &--current {
      font-weight: 700;
      font-size: 4rem;
    }
  }
  &__progressbar {
    background: #cce9ff;
    border-radius: 8px;
    max-width: 41rem;
    width: 100%;
    height: 1.2rem;
    margin: 0 3.2rem;
    &--inner {
      background: #46adf4;
      border-radius: 8px;
      width: 33.3%;
      height: 100%;
      transition: all 0.3s;
    }
  }
  &__button {
    cursor: pointer;
    transition: 0.2s all;
    &:focus {
      outline: none;
    }
    &:hover {
      background: #0082be;
    }
    &:disabled {
      background: #b2e7ff;
    }
    background: #005177;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 6rem;
    &--right {
      border-radius: 0 8px 8px 0;
      position: relative;
    }
    &--seperator {
      position: absolute;
      background-color: #486c7d;
      width: 4rem;
      height: 2px;
      transform: rotate(90deg);
      top: 50%;
      left: -40%;
    }
    &--left {
      border-radius: 8px 0 0 8px;
    }
    &-wrapper {
      display: flex;
    }
  }
  @media (max-width: 950px) {
    &__control {
      align-items: center;
      justify-content: space-around;
    }
    &__progressbar {
      display: none;
    }
    &__illust {
      width: 35vw;
    }
    &__indicator {
      order: 1;
      width: auto;
    }
    &__button {
      width: 50px;
      height: 50px;
      &--left {
        order: 0;
      }
      &--right {
        order: 2;
      }
      &--seperator {
        display: none;
      }
    }
  }
  @media (max-width: 650px) {
    &__illust {
      width: 100%;
      margin-top: 1rem;
    }
  }
}
</style>
